<div mat-dialog-content class="dialog-content">
  <image-cropper
    [format]="outputFormat"
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="ratio"
    [resizeToWidth]="cropperSize"
    [resizeToHeight]="cropperSize"
    [roundCropper]="true"
    (imageCropped)="imageCropped($event)"
    [imageQuality]="imageQuality"
  >
  </image-cropper>
  <div class="button-container">
    <button class="btn btn-cancel" (click)="onCancel()">{{ 'business_card.btn_cancel' | translate }}</button>
    <button class="btn btn-delete" (click)="onCrop()">{{ 'business_card.btn_crop' | translate }}</button>
  </div>
</div>
